export default __webpack_public_path__ + "static/media/user-round.3c0a422b.jpg";